import React from 'react';
import { findDOMNode } from "react-dom";
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import Popper from 'popper.js';
import logo from './logo.svg';
import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';

import Pages from './pages';



import Session_Year from './user_pages/session_year';
import Fee_Categories from './user_pages/fee_categories';
import Class_Master from './user_pages/class_master';
import Class_Fee_Master from './user_pages/class_fee_master';
import View_Class_Fee_Master from './user_pages/view_class_fee_master';
import View_Student_Admission from './user_pages/view_student_admission';
import View_Student_Performance from './user_pages/view_student_performance';
import View_Fee_Transactions from './user_pages/view_fee_transactions';
import View_Student_Wise_Due from './user_pages/view_student_wise_due';
import Student_Fee_Allotment from './user_pages/student_fee_allotment';
import Submit_Fee from './user_pages/submit_fee';



// Building Related Components





//import Salary_Mgmt from './user_pages/salary_mgmt';


// LMS Pages
import Category_Master from './lms_pages/category_master';
import Add_Study_Material from './lms_pages/add_study_material';
import View_Study_Material from './lms_pages/view_study_material';
import View_Study_Material_New from './lms_pages/view_study_material_new';
import Course_Curriculam_Mapping from './lms_pages/course_curriculam_mapping';
import Course_Curriculam from './lms_pages/course_curriculam';
import Academic_Year from './lms_pages/academic_year';
import Academic_Program from './lms_pages/academic_program';
import Institutions from './lms_pages/institutions';
import View_Employee from './lms_pages/view_employee';
import Student_Admission from './lms_pages/student_admission';
import Student_Bulk_Import from './lms_pages/student_bulk_import';
import DashboardNew from './lms_pages/dashboard_new';
import Quiz_Creation from './lms_pages/quiz_creation';
import Cadet_Record_Book from './lms_pages/cadet_record_book';
import Candidate_CRB from './lms_pages/candidate_crb';
import DNS_Marksheet from './lms_pages/dns_marksheet';
import Pre_Sea_Training from './lms_pages/pre_sea_training';

import View_Student_Tab_Allotment from './lms_pages/view_student_tab_allotment';
import View_Student_Officer_Mapping from './lms_pages/view_student_officer_mapping';

import Member_Profile from './lms_pages/member_profile';
import Update_Android_Verion from './lms_pages/update_android_version';
import View_Study_Books_for_Members from './lms_pages/view_study_books_for_members';
import View_Study_Books_ByCategories from './lms_pages/view_study_books_bycategories';
import View_Task_List from './lms_pages/view_task_list'; 

import Student_Certificates from './lms_pages/student_certificates';
import Student_Ship_Records from './lms_pages/student_ship_records';

import View_Bridge_WatchKeeping_Admin from './lms_pages/view_bridge_watchkeeping_admin';
import View_Steering_Records_Admin from './lms_pages/view_steering_records_admin';
import View_Port_Watches_Records_Admin from './lms_pages/view_port_watches_records_admin';
import View_Engine_Room_Watched_Admin from './lms_pages/view_engine_room_watched_admin';
import Member_Login from './pages/member_login';

import Ship_Particular from './lms_pages/ship_particular';
import View_Ship_Particulars from './user_pages/view_ship_particulars';
import Cadet_Ship_Particular from './lms_pages/cadet_ship_particular';
import View_CTO from './lms_pages/view_cto';
import View_STO from './lms_pages/view_sto';
import View_MTO from './lms_pages/view_mto';
import View_Ship_Masters from './lms_pages/view_ship_masters';

import View_Bridge_Watch_Keeping_Records from './lms_pages/view_bridge_watch_keeping_records';
import View_Steering_Records from './lms_pages/view_steering_records';
import View_Port_Watches_Records from './lms_pages/view_port_watches_records';
import View_Engine_Room_Watched from './lms_pages/view_engine_room_watched';

import View_Sea_Service_Records from './lms_pages/view_sea_service_records';
import Sto_Monthly_Review from './lms_pages/sto_monthly_review';
import Masters_Monthly_Review from './lms_pages/masters_monthly_review';
import Institute_Monthly_Review from './lms_pages/institute_monthly_review';

import View_Users_Log from './lms_pages/view_users_log';
import View_Task_List_Admin from './lms_pages/view_task_list_admin';

import Cadet_Data_Sync from './lms_pages/cadet_data_sync';
import Member_Notification from './lms_pages/memeber_notification';
import Student_Performance_Task from './user_pages/student_performance_task';


class App extends React.Component{
  componentDidMount() {
    // const script = document.createElement("script");    
    // script.async = true;    
    // script.src = "./assets/js/default/active.js"; 
    // document.body.appendChild(script);   
      }
  render(){
   
    return <Router>
      <Route exact path="/" component={Pages} />
      {/* <Route exact path="/" component={Member_Login}/> */}
      <Route exact path="/member/ebooks" component={View_Study_Books_for_Members}/>
      <Route exact path="/cadet/task_list" component={View_Task_List}/>
      <Route exact path="/student_task_list" component={View_Task_List_Admin}/>
      <Route exact path="/task_list" component={View_Task_List}/>
      <Route exact path="/member/ebooks_by_categories" component={View_Study_Books_ByCategories}/>
      {/* routes of student  */}
      <Route exact path="/member/my_profile" component={Member_Profile}/>
      <Route exact path="/member/update_android_verion" component={Update_Android_Verion}/>
      <Route exact path="/cadet_data_sync" component={Cadet_Data_Sync}/>
      <Route exact path="/member_notification" component={Member_Notification}/>

      {/* routes for University */}
      <Route exact path="/Dashboard" component={DashboardNew}/>
      <Route exact path="/academic_year" component={Academic_Year} />
      <Route exact path="/academic_program" component={Academic_Program} />
      <Route exact path="/course_curriculam" component={Course_Curriculam} />
      <Route exact path="/course_curriculam_mapping" component={Course_Curriculam_Mapping} />
      <Route exact path="/student_admission" component={Student_Admission} />
      <Route exact path="/student_bulk_import" component={Student_Bulk_Import}/>
      <Route exact path="/staff_users" component={View_Employee}/>
      <Route exact path="/institution" component={Institutions}/>
      <Route exact path="/addstudymaterial" component={Add_Study_Material}/>
      <Route exact path="/category_function"  component={Category_Master}/>
      <Route exact path="/view_study_material" component={View_Study_Material_New}/>
      <Route exact path="/quiz_creations" component={Quiz_Creation}/>
      <Route exact path="/cadet_record_book" component={Cadet_Record_Book} />
      <Route exact path="/pre_sea_training" component={Pre_Sea_Training} />
      <Route exact path="/dns_marksheet" component={DNS_Marksheet} />

      <Route exact path="/ship_particular" component={Ship_Particular}/>
      <Route exact path="/view_ship_particulars" component={View_Ship_Particulars}/>

      <Route exact path="/cadet_ship_particular" component={Cadet_Ship_Particular}/>
      <Route exact path="/cadet_ship_particulars" component={Cadet_Ship_Particular}/>

      <Route exact path="/view_sto" component={View_STO}/>
      <Route exact path="/view_cto" component={View_CTO}/>
      <Route exact path="/view_mto" component={View_MTO}/>
      <Route exact path="/view_ship_masters" component={View_Ship_Masters}/>

      <Route exact path="/cadet/sto_master" component={View_STO}/>
      <Route exact path="/cadet/cto_master"  component={View_CTO}/>


      {/* <Route exact  path="/student_ship_records/:name" component={Student_Ship_Records}/> */}
      <Route exact  path="/student_ship_records/records_of_steering" component={View_Steering_Records_Admin}/>
      <Route exact  path="/student_ship_records/records_of_port_watches" component={View_Port_Watches_Records_Admin}/>
      {/* <Route exact  path="/student_ship_records/records_of_engine_room_watches" component={Student_Ship_Records}/> */}
      <Route exact path="/student_ship_records/records_of_engine_room_watches" component={View_Engine_Room_Watched_Admin}/>
      <Route exact  path="/student_ship_records/record_of_bridge_watchkeeping" component={View_Bridge_WatchKeeping_Admin}/>
      {/* <Route exact path="/student_certificates/:name" component={Student_Certificates}/> */}
      <Route exact path="/student_certificates/steering_certificate" component={Student_Certificates}/>
      <Route exact path="/student_certificates/bridge_watchkeeping_certificate" component={Student_Certificates}/>
      <Route exact path="/student_certificates/port_watchkeeping_certificate" component={Student_Certificates}/>
      <Route exact path="/student_certificates/engine_room_watchkeeping_certificate" component={Student_Certificates}/>

      <Route exact path="/cadet/view_bridge_watch_keeping_records" component={View_Bridge_Watch_Keeping_Records} />
      <Route exact path="/cadet/view_steering_records" component={View_Steering_Records}/>
      <Route exact path="/cadet/view_port_watches_records" component={View_Port_Watches_Records}/>
      <Route exact path="/cadet/view_engine_room_watched" component={View_Engine_Room_Watched}/>
      

      <Route exact path="/cadet/view_sea_service_records" component={View_Sea_Service_Records}/>
      <Route exact path="/cadet/sto_monthly_review" component={Sto_Monthly_Review}/>
      <Route exact path="/cadet/masters_monthly_review" component={Masters_Monthly_Review}/>
      <Route exact path="/cadet/institute_monthly_review" component={Institute_Monthly_Review}/>
      <Route exact path="/cadet/cadet_record_book" component={Candidate_CRB}/>
      {/* end of University */}
      
      
      {/* <Route exact path="/opd_reports" component={Opd_Reports} /> */}
      {/* <Route exact path="/ipd_reports" component={Ipd_Reports} /> */}
      
      <Route exact path="/fee_categories" component={Fee_Categories} />
      
      <Route exact path="/class_fee_master" component={Class_Fee_Master} />
      <Route exact path="/view_class_fee_master" component={View_Class_Fee_Master} />
      <Route exact path="/view_student_admission" component={View_Student_Admission}/>
      <Route exact path="/student_performance" component={View_Student_Performance}/>
      <Route exact path="/student_performance_task" component={Student_Performance_Task} />
      <Route exact path="/student_fee_allotment" component={Student_Fee_Allotment}/>
      <Route exact path="/Submit_Fee" component={Submit_Fee}/>
      
      <Route exact path="/view_fee_transactions" component={View_Fee_Transactions} />
      <Route exact path="/view_student_wise_due" component={View_Student_Wise_Due}/>
      <Route exact path="/view_users_log" component={View_Users_Log}/>
      {/* building related components */}
    
      <Route exact path="/view_employee" component={View_Employee}/>
      <Route exact path="/stu_tab_allotment" component={View_Student_Tab_Allotment}/>
      <Route exact path="/stu_officer_mapping" component={View_Student_Officer_Mapping}/>
      {/* <Route exact path="/salary_mgmt" component={Salary_Mgmt}/> */}

    
    </Router>
  }
  
}
export default App;